// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feature-grid[data-v-8ee76e3c]{display:grid;grid-template-columns:1fr;grid-gap:2rem;margin-top:2rem}@media (min-width:768px){.feature-grid[data-v-8ee76e3c]{grid-template-columns:repeat(2,1fr)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
